import {useState} from "react";
import Nav from "../components/Nav";
import {useCookies} from "react-cookie";
import axios from "axios";
import {useNavigate} from "react-router-dom";

const Onboarding = () => {
    const [cookies,setCookies,removeCookies] = useCookies(['user'])
    let navigate = useNavigate()
    const [formData,setFormData] = useState({
        user_id:cookies.UserId,
        first_name:'',
        dob_day:'',
        dob_month:'',
        dob_year:'',
        show_gender:false,
        gender_identity:'man',
        gender_interest:'woman',
        email:cookies.email,
        url:'',
        about:'',
        matches:[]
    })
    const handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value === 'checkbox' ? e.target.checked : e.target.value
        setFormData((prevState)=>({
            ...prevState,
            [name]:value
        }))
        console.log(formData)
    }
    const handleSubmit = async(e) => {
        e.preventDefault()
        try {

            const response = await axios.put(`https://match-app-backend.herokuapp.com/user`, {
              formData
            })
            const success = response.status === 200
            if (success) navigate('/dashboard')
        } catch (error) {
            console.log(error)
        }

    }
    return (
        <>
            <Nav
                setShowModal={() => {
                }}
                showModal={false}
            />
            <div className={'onboarding'}>
                <h2>Create Account</h2>
                <form action="" onSubmit={handleSubmit}>
                    <section>
                        <label htmlFor="first_name">First Name</label>
                        <input type="text"
                               name={'first_name'}
                               id={'first_name'}
                               placeholder={'First Name'}
                               required={true}
                               value={formData.first_name}
                               onChange={handleChange}/>

                        <label htmlFor="birthday">Birthday</label>
                        <div className={'multiple-input-container'}>
                            <input type="number"
                                   name={'dob_year'}
                                   id={'dob_year'}
                                   placeholder={'Year'}
                                   required={true}
                                   value={formData.dob_year}
                                   onChange={handleChange}/>
                            <input type="number"
                                   name={'dob_month'}
                                   id={'dob_month'}
                                   placeholder={'Month'}
                                   required={true}
                                   value={formData.dob_month}
                                   onChange={handleChange}/>
                            <input type="number"
                                   name={'dob_day'}
                                   id={'dob_day'}
                                   placeholder={'Day'}
                                   value={formData.dob_day}
                                   required={true}
                                   onChange={handleChange}/>

                        </div>

                        <label htmlFor="gender">Gender</label>
                        <div className={'multiple-input-container'}>
                            <input type="radio"
                                   name={'gender_identity'}
                                   id={'woman-gender-identity'}
                                   required={true}
                                   onChange={handleChange}
                                   value={'woman'}
                                   checked={formData.gender_identity === 'woman'}/>
                            <label htmlFor='woman-gender-identity'>Woman</label>
                            <input type="radio"
                                   name={'gender_identity'}
                                   id={'man-gender-identity'}
                                   required={true}
                                   onChange={handleChange}
                                   value={'man'}
                                   checked={formData.gender_identity === 'man'}/>
                            <label htmlFor='man-gender-identity'>Man</label>
                            <input type="radio"
                                   name={'gender_identity'}
                                   id={'other-gender-identity'}
                                   required={true}
                                   onChange={handleChange}
                                   value={'other'}
                                   checked={formData.gender_identity === 'other'}/>
                            <label htmlFor='other-gender-identity'>Other</label>
                        </div>
                        <label htmlFor="show-gender">Show Gender on My Profile</label>
                        <input type="checkbox"
                               name={'show_gender'}
                               id={'show-gender'}
                               placeholder={'First Name'}
                               required={true}
                               onChange={handleChange}
                             />

                        <label>Show Me</label>
                        <div className={'multiple-input-container'}>
                            <input type="radio"
                                   name={'gender_interest'}
                                   id={'woman-gender-interest'}
                                   required={true}
                                   onChange={handleChange}
                                   value={'woman'}
                                   checked={formData.gender_interest === 'woman'}/>
                            <label htmlFor='woman-gender-interest'>Woman</label>
                            <input type="radio"
                                   name={'gender_interest'}
                                   id={'man-gender-interest'}
                                   required={true}
                                   onChange={handleChange}
                                   value={'man'}
                                   checked={formData.gender_interest === 'man'}/>
                            <label htmlFor='man-gender-interest'>Man</label>
                            <input type="radio"
                                   name={'gender_interest'}
                                   id={'other-gender-interest'}
                                   required={true}
                                   onChange={handleChange}
                                   value={'other'}
                                   checked={formData.gender_interest === 'other'}/>
                            <label htmlFor='other-gender-interest'>Everyone</label>
                        </div>


                        <label htmlFor='about'>About Me</label>
                        <input type="text"
                               id={'about'}
                               name={'about'}
                               required={true}
                               value={formData.about}
                               onChange={handleChange}/>
                        <input type="submit"
                               onSubmit={handleSubmit}/>
                    </section>
                    <section>
                        <label htmlFor='about'>Profile Photo</label>
                        <input type="url"
                               id={'url'}
                               name={'url'}
                               required={true}
                               onChange={handleChange}/>
                        <div className={'photo-container'}>
                            {formData.url && <img src={formData.url} alt="Profile Pic"/>}
                        </div>
                    </section>
                </form>
            </div>
        </>
    )
}

export default Onboarding